import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';

export const InvalidPhoneModal = (props: AlertProps) => (
    <Alert
        {...props}
        title="Ошибка в номере телефона"
        description="Пожалуйста, проверьте номер телефона и убедитесь, что он введён корректно."
        button={
            <DrawerBottomFixed>
                <DrawerButton onClick={props.onClose}>Закрыть</DrawerButton>
            </DrawerBottomFixed>
        }
    />
);
